import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BlurScreenService {
    private blurState$ = new BehaviorSubject<boolean>(false);

    /**
     * Get the current blur state as an Observable
     * @returns Observable of blur state
     */
    getBlurState(): Observable<boolean> {
        return this.blurState$.asObservable();
    }

    /**
     * Get the current blur state value
     * @returns Current blur state
     */
    getBlurStateValue(): boolean {
        return this.blurState$.value;
    }

    /**
     * Enable blur screen
     */
    enableBlur(): void {
        this.blurState$.next(true);
    }

    /**
     * Disable blur screen
     */
    disableBlur(): void {
        this.blurState$.next(false);
    }

    /**
     * Toggle blur screen
     */
    toggleBlur(): void {
        this.blurState$.next(!this.blurState$.value);
    }
}

